// @ts-nocheck
import Events from '../constants/events';
import { siteApi } from '../services';
import { hasChanged, handleError } from '../utilities';

class ComplianceRequests {
  constructor() {
    this.complianceRequests = [];

    this.loading = false;
  }

  async refreshData() {
    try {
      this.loading = true;
      window.dispatchEvent(new CustomEvent(Events.ComplianceRequestsLoading));
      const results = await siteApi.getComplianceRequests();
      const originalData = this.complianceRequests;
      this.complianceRequests = results.items;
      if (hasChanged(results.items, originalData)) {
        window.dispatchEvent(new CustomEvent(Events.ComplianceRequestsChanged));
      }
      window.dispatchEvent(new CustomEvent(Events.ComplianceRequestsLoaded));
    } catch (err) {
      handleError(err);
    } finally {
      this.loading = false;
    }
  }
}

export const complianceRequests = new ComplianceRequests();
